import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  label: ReactNode;
  orientation?: 'horizontal' | 'vertical';
};

const DefinitionListItem = ({
  children,
  label,
  orientation = 'horizontal'
}: Props) => {
  const isHorizontal = orientation === 'horizontal';

  return (
    <Stack direction={isHorizontal ? 'row' : 'column'} spacing={2}>
      <Typography component="dt" fontWeight={700} variant="body1" width={isHorizontal ? '15%' : '100%'} minWidth={200}>
        {label}
      </Typography>
      <Typography component="dd" variant="body1" width={isHorizontal ? '85%' : '100%'} marginLeft="auto">
        {children}
      </Typography>
    </Stack>
  );
};

export default DefinitionListItem;
